module.exports = __webpack_public_path__ + "static/values-create-tomorrow-d6ad27259d442c57538af42e7409f9f4.svg";